<kendo-dialog *ngIf="editFormActive" (close)="closeEditForm()" [width]="900">
    <kendo-dialog-titlebar>
        <h3>{{ (isNew ? 'ADD-ANALYTIC' : 'EDIT-ANALYTIC') | translate }}</h3>
    </kendo-dialog-titlebar>
    <form novalidate [formGroup]="editForm" class="k-form">
        <div class="row">
            <!--name-->
            <div class="col-6">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'NAME' | translate}} *
                    </span>
                    <input id="name" kendoTextBox formControlName="name" maxlength="30" />
                    <div class="k-tooltip k-tooltip-validation" *ngIf="name.hasError('required') && name.touched"
                        role="alert">
                        {{'REQUIRED-NAME' | translate}}
                    </div>
                    <div class="k-tooltip k-tooltip-validation" *ngIf="name.hasError('nameExists')" role="alert">
                        {{'ANALYTIC-ALREADY-EXISTS' | translate}}
                    </div>
                </label>
            </div>
            <!--link-->
            <div class="col-6">
                <label class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{'LINK' | translate}} *
                    </span>
                    <input id="link" kendoTextBox formControlName="link" maxlength="255" />
                    <div class="k-tooltip k-tooltip-validation" *ngIf="link.hasError('required') && link.touched"
                        role="alert">
                        {{'REQUIRED-LINK' | translate}}
                    </div>
                    <div class="k-tooltip k-tooltip-validation"
                        *ngIf="!isValidUri(link) && link.hasError('pattern') && link.touched" role="alert">
                        {{'INVALID-URL' | translate}}
                    </div>
                </label>
            </div>
        </div>
        <!--description-->
        <div class="row">
            <div class="col-12">
                <label for="description" class="k-form-field">
                    <span class="k-text-uppercase dark">
                        {{ 'DESCRIPTION' | translate }}
                    </span>
                    <textarea id="description" kendoTextArea class="w-100 k-textarea" rows="3"
                        formControlName="description" maxlength="1000" style="max-height: 300px;">
                    </textarea>
                </label>
            </div>
        </div>
        <label class="k-text-uppercase dark mr-2 pt-3" for="enabled">{{ 'ENABLED' | translate }}</label>
        <kendo-switch formControlName="enabled" onLabel="{{'YES' | translate }}" offLabel="{{'NO' | translate }}">
        </kendo-switch>
    </form>
    <div>* {{'REQUIRED-FIELDS' | translate}}</div>
    <kendo-dialog-actions>
        <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick class="k-button k-primary" [disabled]="!editForm.valid || !editForm.dirty"
            (click)="onSave($event)">{{ 'SAVE' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>